import {CSSProperties, ReactNode} from "react";

export type ColumnProps = {
    children: ReactNode,
    alignCenter?: boolean,
    fullWidth?: boolean,
    maxWidth?: number,
    style?: CSSProperties
}

export const Column = ({children, alignCenter, fullWidth, maxWidth,style}:ColumnProps) => {
    const _style:CSSProperties = {
        display: "flex",
        flexDirection: "column",
        alignItems: alignCenter ? "center" : undefined,
        width: fullWidth ? "100%" : undefined,
        maxWidth: maxWidth ? maxWidth : undefined,
        ...style
    }

    return (
        <div style={_style}>
            {children}
        </div>
    )
}
